import { useRef } from "react";

export function ProductImageSlide({ media, isActive }) {
  const video = useRef(null);

  if (isActive && media.media_type === "video") {
    if (video) {
      video.current.load();
      video.current.play();
    }
  }

  if (media.media_type === "image") {
    return (
      <div className="aspect-[5/6]">
        <img src={media.preview_image.src} alt={media.alt} className="h-full w-full object-center object-cover" />
      </div>
    )
  }

  if (media.media_type === "video") {
    return (
      <div className="aspect-[5/6] relative">
        <video className="h-full w-full object-center object-cover" ref={video} playsInline={true} controls={true} autoPlay={false} preload="none" muted={true} aria-label="Variant images" poster={media.preview_image.src}>
          <source src={media.sources[0].url} type="video/mp4" />
          <img src={media.preview_image.src} />
        </video>
      </div>
    )
  }
}